// extracted by mini-css-extract-plugin
export default {"ball":"Ball_ball__syGrW","scale":"Ball_scale__dwPbe","ball-scale":"Ball_ball-scale__dancW"};